import { render, staticRenderFns } from "./SalesDifference.vue?vue&type=template&id=065c1ca3"
import script from "./SalesDifference.vue?vue&type=script&lang=js"
export * from "./SalesDifference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports